export function joinWindowState(input, _now = new Date()) {
    if (input.status === 'cancelled')
        return 'cancelled';
    if (input.status === 'ended')
        return 'ended';
    return 'open';
}
//# sourceMappingURL=joinWindow.js.map